import PropTypes from 'prop-types';

const SurveyQuestionShape = PropTypes.shape({
  order: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  next: PropTypes.object.isRequired,
  answers: PropTypes.object.isRequired,
  prev: PropTypes.string,
  other_answer: PropTypes.object,
  tooltip: PropTypes.string,
  sub_text: PropTypes.string,
});

export default SurveyQuestionShape;
